import type { components } from '@fluencelabs/vodopad-admin-api'
import { useState } from 'react'

import { useUserActions } from './useUserActions'

type AdminUserDto = components['schemas']['AdminUserDto']
type ActionModal = 'balance' | 'role' | 'group' | null

interface ActionMenuItem {
  key: string
  label: string
  [key: `data-${string}`]: string | undefined
}

export function useUserActionMenu() {
  const [activeModal, setActiveModal] = useState<ActionModal>(null)
  const [targetUserId, setTargetUserId] = useState('')
  const [modalExtra, setModalExtra] = useState<Record<string, unknown>>({})
  const actions = useUserActions()

  const openModal = (
    modal: ActionModal,
    userId: string,
    extra?: Record<string, unknown>,
  ) => {
    setActiveModal(modal)
    setTargetUserId(userId)
    setModalExtra(extra ?? {})
  }

  const closeModal = () => {
    setActiveModal(null)
    setTargetUserId('')
    setModalExtra({})
  }

  const handleAction = (
    key: string,
    user: { id: string; email: string; roleName: string; groupName: string },
  ) => {
    switch (key) {
      case 'balance':
        openModal('balance', user.id, { email: user.email })
        break
      case 'role':
        openModal('role', user.id, {
          email: user.email,
          currentRole: user.roleName,
        })
        break
      case 'group':
        openModal('group', user.id, {
          email: user.email,
          currentGroup: user.groupName,
        })
        break
    }
  }

  const getMenuItems = (_user: AdminUserDto): ActionMenuItem[] => [
    { key: 'balance', label: 'Change Balance' },
    { key: 'role', label: 'Set Role' },
    { key: 'group', label: 'Set Group' },
  ]

  return {
    activeModal,
    targetUserId,
    modalExtra,
    openModal,
    closeModal,
    handleAction,
    getMenuItems,
    actions,
  }
}
